var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "27px",
    viewBox: "0 0 29 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "audio-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "auto",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content-Blocks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "audio-white",
    transform: "translate(-14.000000, -12.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.000000, 12.643541)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 0.356459)",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "12.4530201 1.3559322e-05 5.19016842 5.97696271 4.42532632 6.60611525 -1.33971292e-05 6.60611525 -1.33971292e-05 17.0861153 4.16368038 17.0861153 5.19016842 17.930861 12.4530201 23.9078102"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(15.138756, 0.314576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.57152153,23.2152136 C7.33573206,23.2152136 7.09980861,23.1261288 6.91720574,22.946739 C6.54516746,22.5809085 6.53632536,21.9791458 6.8977799,21.6024678 C9.47418182,18.9165017 10.8933397,15.378061 10.8933397,11.6393492 C10.8933397,7.90077288 9.47418182,4.36219661 6.8977799,1.67609492 C6.53632536,1.29968814 6.54516746,0.697925424 6.91720574,0.332094915 C7.28964593,-0.0338711864 7.88421053,-0.0246508475 8.24526316,0.351891525 C11.1642297,3.39501017 12.7716172,7.40355254 12.7716172,11.6393492 C12.7716172,15.8752814 11.1642297,19.8838237 8.24526316,22.9268068 C8.0611866,23.1186712 7.81628708,23.2152136 7.57152153,23.2152136",
    id: "Fill-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.28659904,19.8096136 C4.05496268,19.8096136 3.82252249,19.7232407 3.64099139,19.549139 C3.26426411,19.1880542 3.24832153,18.5862915 3.60508708,18.2054102 C5.27718278,16.4200542 6.19756555,14.0882576 6.19756555,11.6391729 C6.19756555,9.19063051 5.27718278,6.85869831 3.60508708,5.07347797 C3.24832153,4.69259661 3.26426411,4.09069831 3.64099139,3.72961356 C4.01745072,3.36852881 4.61188134,3.38439322 4.96864689,3.76595254 C6.97232153,5.90574915 8.07584306,8.70168136 8.07584306,11.6391729 C8.07584306,14.5768 6.97232153,17.3730034 4.96864689,19.5129356 C4.78403445,19.7103593 4.53538373,19.8096136 4.28659904,19.8096136",
    id: "Fill-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.00103349,16.4032407 C0.779177033,16.4032407 0.556650718,16.3240542 0.377397129,16.1631051 C-0.0103157895,15.8144949 -0.0451483254,15.2139525 0.299425837,14.8212746 C1.0747177,13.9381559 1.50181818,12.808122 1.50181818,11.6391729 C1.50181818,10.4704949 1.0747177,9.34059661 0.299425837,8.45747797 C-0.0451483254,8.0648 -0.0103157895,7.46425763 0.377397129,7.11551186 C0.76537799,6.76690169 1.3584689,6.80174915 1.703311,7.19442712 C2.7845933,8.42629153 3.38009569,10.0045966 3.38009569,11.6391729 C3.38009569,13.2738847 2.7845933,14.852461 1.703311,16.0841898 C1.51762679,16.2955797 1.26,16.4032407 1.00103349,16.4032407",
    id: "Fill-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioWhite);
export default __webpack_public_path__ + "static/media/audio-white.edd25d45.svg";
export { ForwardRef as ReactComponent };